export enum TipoPerguntaEnum {
  ESCALA = "ESCALA",
  BOOLEANO = "BOOLEANO",
  TEXTO = "TEXTO",
}
